"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _TableMobileRow = _interopRequireDefault(require("./TableMobileRow"));

var _TableSectionHeader = _interopRequireDefault(require("../section/TableSectionHeader"));

var _styling = require("../../../../toolkit/styling");

var _device = require("../../../../toolkit/device");

//
//  src/data/table/mobile/MobileMerchantTable.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 4/1/2020.
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var _default = (0, _mobxReact.observer)(function (_ref) {
  var sections = _ref.sections,
      columns = _ref.columns,
      className = _ref.className,
      style = _ref.style;

  var _useDeviceStore = (0, _device.useDeviceStore)(),
      isSmallScreen = _useDeviceStore.isSmallScreen;

  var styles = useStylesheet();

  if (!isSmallScreen) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(className, style, styles.root)
  }, sections.map(function (section) {
    var data = section.data,
        _section$config = section.config,
        sectionKey = _section$config.sectionKey,
        header = _section$config.header;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _styling.css)(styles.section),
      key: sectionKey
    }, header != null && /*#__PURE__*/_react["default"].createElement(_TableSectionHeader["default"], {
      section: section
    }), data.map(function (row, index) {
      var rowContext = {
        row: row,
        index: index,
        section: section
      };
      return /*#__PURE__*/_react["default"].createElement(_TableMobileRow["default"] // no other key available, can't use object has
      // because of encoding error.
      // eslint-disable-next-line react/no-array-index-key
      , {
        key: "row-index-".concat(index),
        row: rowContext,
        rowIndex: index,
        section: section,
        columns: columns,
        className: (0, _styling.css)(styles.row)
      });
    }));
  }));
});

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      },
      section: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      },
      row: {
        margin: "10px 0px"
      }
    });
  }, []);
};